// extracted by mini-css-extract-plugin
export default {"footer":"styles_footer__2uRP6","deleteButton":"styles_deleteButton__Gh2yF","devider":"styles_devider__t+6Ag"};